import React from "react";

const SearchIcon = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none">
    <path
      d="M18.5 18L15.6 15.1M17.1667 11.3333C17.1667 14.2789 14.7789 16.6667 11.8333 16.6667C8.88781 16.6667 6.5 14.2789 6.5 11.3333C6.5 8.38781 8.88781 6 11.8333 6C14.7789 6 17.1667 8.38781 17.1667 11.3333Z"
      stroke="#8F8F8F"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SearchIcon;
